export default __webpack_public_path__ + "static/media/Advanced Potion Making - Spells_03.e318a90e.jpg";